import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall, postApiCallWithAbort } from "../../utils/ApiMethods";


const FetchSpendDetailAction = (requestObj, signal) => {
    return async function (dispatch) {
       // const data = await postApiCall(`${appConstants.BASE_URL}/spend-analytics/kpi-page-data`, requestObj)
        const data = await postApiCallWithAbort(`${appConstants.BASE_URL}/spend-analytics/kpi-page-data`, requestObj, signal)
        if(data) {
            var resData = Object.assign({ type: 'SUCCESS_SPEND_DETAIL_VIEW_ACTION' }, data);
            dispatch(resData);
        }
    }
}

export {
    FetchSpendDetailAction
}